import * as React from 'react';
import { useContext } from 'react';

import type { DiscoveryCollection } from 'bundles/browse/components/types/DiscoveryCollections';

const RecommendationsContext = React.createContext<Array<DiscoveryCollection | null> | undefined>(undefined);

export const useRecommendations = () => {
  const recommendations = useContext(RecommendationsContext);

  return recommendations;
};

export default RecommendationsContext;
